import * as React from 'react'

import { cn } from '@/lib/utils'
import { EyeIcon, EyeOffIcon } from 'lucide-react'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    loading?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false)
    const [isFocused, setIsFocused] = React.useState(false)

    const handleFocus = () => {
        setIsFocused(true)
    }

    const handleBlur = () => {
        setIsFocused(false)
    }

    const toggleShowPassword = () => setShowPassword(!showPassword)

    return (
        <>
            {type === 'password' ? (
                <div
                    className={cn(
                        `flex items-center h-10 w-full rounded-md border ${
                            isFocused ? 'ring-2 ring-slate-400' : 'border-slate-200'
                        } bg-white text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-800 dark:bg-slate-950 dark:ring-offset-slate-950 dark:placeholder:text-slate-400 dark:focus-visible:ring-slate-800 overflow-hidden relative`,
                        className
                    )}
                    tabIndex={0}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                >
                    <input
                        type={showPassword ? 'text' : 'password'}
                        ref={ref}
                        {...props}
                        className='w-full h-full px-3 py-2 outline-none'
                    />

                    <div className='absolute cursor-pointer right-3' onClick={toggleShowPassword}>
                        {showPassword ? <EyeIcon size={18} /> : <EyeOffIcon size={18} />}
                    </div>
                </div>
            ) : (
                <input
                    type={type}
                    className={cn(
                        'flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-800 dark:bg-slate-950 dark:ring-offset-slate-950 dark:placeholder:text-slate-400 dark:focus-visible:ring-slate-800',
                        className
                    )}
                    ref={ref}
                    {...props}
                />
            )}
        </>
    )
})
Input.displayName = 'Input'

export { Input }
